import { useEffect } from 'react'

import { useGetDemoOrgIdsQuery } from 'shared/api/auth/requests'
import { INNOSCRIPTA_INTERNAL_ORGANIZATION_ID } from 'shared/constants/user'
import { useCommonStore } from 'shared/stores/commonStore'

export const useGetDemoOrgIds = () => {
  const setDemoOrgIds = useCommonStore(state => state.setDemoOrgIds)
  const { data, error } = useGetDemoOrgIdsQuery()

  useEffect(() => {
    if (data) {
      const orgIds = data.map(item => item.org_id)
      setDemoOrgIds(orgIds)
    }
  }, [data, setDemoOrgIds])

  useEffect(() => {
    if (error) {
      setDemoOrgIds([INNOSCRIPTA_INTERNAL_ORGANIZATION_ID])
    }
  }, [error, setDemoOrgIds])
}
